import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import useAuth from "./hooks/useAuth";
import AuthContext from "./context/AuthContext";
import { useContext } from "react";

import LoginPage from "./pages/LoginPage/LoginPage";
import RegisterPage from "./pages/RegisterPage/RegisterPage";
import ResetPasswordPage from "./pages/ResetPasswordPage/ResetPasswordPage";
import ReceiptSubmissionPage from "./pages/ReceiptSubmissionPage/ReceiptSubmissionPage";
import AdminDashboardPage from "./pages/AdminDashboardPage/AdminDashboardPage";
import UserDashboardPage from "./pages/UserDashboardPage/UserDashboardPage";
import MissingReceiptsPage from "./pages/MissingReceiptsPage/MissingReceiptsPage";

import Navbar from "./components/NavBar/NavBar";
import Footer from "./components/Footer/Footer";
import PrivateRoute from "./utils/PrivateRoute";
import useIdleTimeout from "./hooks/useIdleTimeout";

function RoleRedirect() {
  const [user] = useAuth();
  if (!user) return <Navigate to="/login" />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} />;
}

function IdleWarningModal({ onStay, onLogout }) {
  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
      display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999,
    }}>
      <div style={{
        background: "#fff", borderRadius: 8, padding: "2rem", maxWidth: 360,
        width: "90%", textAlign: "center", boxShadow: "0 4px 24px rgba(0,0,0,0.2)",
      }}>
        <h3 style={{ marginTop: 0 }}>Still there?</h3>
        <p style={{ color: "#555", marginBottom: "1.5rem" }}>
          You've been inactive for 30 minutes. You'll be logged out automatically at 60 minutes.
        </p>
        <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center" }}>
          <button
            onClick={onStay}
            style={{ padding: "0.5rem 1.25rem", background: "#2563eb", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600 }}
          >
            Stay logged in
          </button>
          <button
            onClick={onLogout}
            style={{ padding: "0.5rem 1.25rem", background: "none", border: "1px solid #ccc", borderRadius: 6, cursor: "pointer" }}
          >
            Log out now
          </button>
        </div>
      </div>
    </div>
  );
}

function AppContent() {
  const { user, logoutUser } = useContext(AuthContext);
  const { showWarning, stayLoggedIn } = useIdleTimeout(logoutUser);

  return (
    <div>
      <Navbar />
      {user && showWarning && (
        <IdleWarningModal onStay={stayLoggedIn} onLogout={logoutUser} />
      )}
      <Routes>
        <Route path="/" element={<RoleRedirect />} />

        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        <Route path="/dashboard" element={<PrivateRoute><UserDashboardPage /></PrivateRoute>} />
        <Route path="/submit" element={<PrivateRoute><ReceiptSubmissionPage /></PrivateRoute>} />
        <Route path="/missing-receipts" element={<PrivateRoute><MissingReceiptsPage /></PrivateRoute>} />
        <Route path="/admin" element={<PrivateRoute requiredRole="admin"><AdminDashboardPage /></PrivateRoute>} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return <AppContent />;
}

export default App;
